import { cloneDeep } from "lodash-es";
import React, { useState } from "react";
import { Form } from "react-final-form";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../components/DetailedErrorAlert";
import { adminApi as api, extractErrorMessage } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { FeeScheduleForm } from "./FeeScheduleForm";

export const CreatePayorGroupFeeScheduleModal = ({ payorGroupId, onCreate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen(!open);

  const handleCreate = async (values) => {
    const newValues = cloneDeep(values);

    setError(null);
    try {
      const res = await api.post("/admin/medicaid_fee_schedules", { medicaid_fee_schedule: snakifyKeys(newValues) });

      if (onCreate) {
        onCreate(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Add Line to Medicaid Fee Schedule
      </Button>

      <Modal isOpen={open} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>Add Medicaid Fee Schedule</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleCreate} initialValues={{ payorGroupId }}>
            {(props) => <FeeScheduleForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
